import GetAppSystemWebApiListRequestModelBase from '../_generated/modelBases/get-app-system-web-api-list-request-model-base';

export default class GetAppSystemWebApiListRequestModel extends GetAppSystemWebApiListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
